import Btn from './Btn';
import { typeKeys, sizeKeys } from './config';
export default Btn;
export { typeKeys as btnTypes, sizeKeys as btnSizes };
